import { EDIT_PROJECT_SUCCESS } from "../../../reducers/settingsReducer";
import { setCurrentProject } from "../../../utils/projectUtils";

export const editProjectSuccess = (project) => {
  setCurrentProject(project, false); // Don't update URL here since it should already be correct
  return {
    type: EDIT_PROJECT_SUCCESS,
    payload: { project },
  };
};
